<template>
  <div class="ProformaCP flex-jc-bt text-left">
    <div class="flex-38">
      <SpCard>
        <p class="fs-int">{{ $l('CargoNameConcerned') }}</p>
        <SpSelect name="4.cargoIds" type="warn" multi-select strategy="fixed" :options="cargoNames" />
        <p class="fs-int">{{ $l('Subject') }}</p>
        <SpInput name="4.subject" text-type="textarea" type="warn" />
      </SpCard>
      <p class="card-tip fs-tip">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-60 right-side sp-color-bg-4">
      <p class="fs-int">{{ $l('Proforma C/P related to this subject') }}</p>
      <p class="fs-int">{{ $l('Method1UploadtheProformaCP') }}</p>
      <SpUpload name="file1" type="primary" :upload-after-select="false" />
      <p class="fs-int">{{ $l('Method2PostPicturesofProformaCP') }}</p>
      <SpUploadGroup name="file2" :upload-after-select="false" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard.vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpInput from '@/components/common/SpInput.vue'
import SpButton from '@/components/common/SpButton.vue'
import SpUploadGroup from '@/components/common/SpUploadGroup.vue'
import SpUpload from '@/components/common/SpUpload.vue'
import useCargoNameOptions from '@/hooks/business/useCargoNameOptions'
import { formatObjFiles } from '@/utils/convert'
import { computed } from 'vue'
export default {
  name: 'ProformaCP',

  nameSpace: 'cargoOwner.cargo.CharteringOrder.AddNewCharteringOrder.ProformaCPVue',

  components: {
    SpCard,
    SpInput,
    SpSelect,
    SpButton,
    SpUploadGroup,
    SpUpload
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  setup (props) {
    const { cargoNames } = useCargoNameOptions()

    // const picFiles = computed(() => {
    //   return formatObjFiles(props.data[4]?.content).filter(f => f.type === 'img')
    // })
    return {
      cargoNames
      // picFiles
    }
  }
}
</script>

<style scoped lang="less">
.ProformaCP{
  margin-top: @gap;
  .card-tip{
    text-indent: 2em;
  }
  .button-back{
    margin-left: @gap;
    margin-top: @gap*7;
  }
  .right-side{
    padding: @gap;
    margin-top: @gap*2;
  }
}
</style>
